/**
 * Cart Quantity Increment - SEO optimized
 * Intercepts fetch requests to /cart/add and multiplies quantity by increment
 */
(function() {
  'use strict';

  var originalFetch = window.fetch;

  window.fetch = function(input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : input.url;

    if (url && url.includes('/cart/add')) {
      try {
        if (init.body instanceof FormData) {
          var formData = init.body;
          var form = document.querySelector('form[data-type="add-to-cart-form"]');

          if (form) {
            var qtyIncrement = parseInt(form.dataset.qtyIncrement, 10);

            if (qtyIncrement && qtyIncrement > 1) {
              var qty = parseInt(formData.get('quantity'), 10) || 1;
              formData.set('quantity', qty * qtyIncrement);
            }
          }
        }
      } catch (e) {
        console.warn('Qty increment logic failed', e);
      }
    }

    return originalFetch(input, init);
  };
})();
